import React, { useState, useEffect } from "react";
import "../ConfigurePayout.css";
import {
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const CreateFranchiesComponent = (props) => {
  const [searchInput, setSearchInput] = useState("");
  const [selectedCohortType, setSelectedCohortType] = useState(null);

  // Cohort type mapping
  const cohortTypeMapping = {
    "13": "PDF",
    "4": "FOCO(City)", 
    "2": "FOFO(Franchise)",
    // Add more mappings as needed
  };

  // Create cohort type options from mapping
  const cohortTypeOptions = Object.entries(cohortTypeMapping).map(([id, name]) => ({
    id: id,
    name: name
  }));

  // Sync selected cohort type with form data
  useEffect(() => {
    if (props.formDataFranchisee?.cohortTypeId) {
      const selected = cohortTypeOptions.find(
        option => option.id === props.formDataFranchisee.cohortTypeId.toString()
      );
      setSelectedCohortType(selected || null);
    } else {
      setSelectedCohortType(null);
    }
  }, [props.formDataFranchisee?.cohortTypeId]);

  // Filter warehouse list based on search input
  const filteredWarehouses = props.warehouseList
    ? props.warehouseList.filter((warehouse) =>
        warehouse.warehouseName
          ?.toLowerCase()
          .includes(searchInput.toLowerCase()) ||
        warehouse.warehouseId?.toString().includes(searchInput)
      )
    : [];

  return (
    <div className="fs-form-column" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {/* Name */}
      <TextField
        className="mui-text-field"
        label="Name"
        name="name"
        value={props.formDataFranchisee?.name}
        onChange={props.handleChangeFranchisee}
        fullWidth
      />

      {/* Description */}
      <TextField
        className="mui-text-field"
        label="Description"
        name="description"
        value={props.formDataFranchisee?.description}
        onChange={props.handleChangeFranchisee}
        fullWidth
      />

      {/* Cohort Type Dropdown - FIXED */}
      <Autocomplete
        options={cohortTypeOptions}
        getOptionLabel={(option) => `${option.name} (ID: ${option.id})`}
        value={selectedCohortType}
        onChange={(event, newValue) => {
          setSelectedCohortType(newValue);
          if (newValue) {
            props.handleChangeFranchisee({
              target: {
                name: "cohortTypeId",
                value: newValue.id,
              },
            });
          } else {
            props.handleChangeFranchisee({
              target: {
                name: "cohortTypeId",
                value: "",
              },
            });
          }
        }}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            className="mui-text-field"
            label="Cohort Type"
            placeholder="Select cohort type"
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {selectedCohortType && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedCohortType(null);
                          props.handleChangeFranchisee({
                            target: {
                              name: "cohortTypeId",
                              value: "",
                            },
                          });
                        }}
                      >
                        {/* <ClearIcon /> */}
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <div style={{ fontWeight: 600 }}>{option.name}</div>
            <div style={{ fontSize: "12px", color: "#666" }}>ID: {option.id}</div>
          </li>
        )}
        noOptionsText="No cohort types found"
      />

      {/* Warehouse Dropdown with Custom Search */}
      <Autocomplete
        options={filteredWarehouses}
        getOptionLabel={(option) =>
          `${option.warehouseName} (ID: ${option.warehouseId})`
        }
        value={
          props.warehouseList?.find(
            (wh) => wh.warehouseId === props.formDataFranchisee?.warehouseId
          ) || null
        }
        onChange={(event, newValue) => {
          if (newValue) {
            props.handleChangeFranchisee({
              target: {
                name: "warehouseId",
                value: newValue.warehouseId,
              },
            });
          } else {
            props.handleChangeFranchisee({
              target: {
                name: "warehouseId",
                value: "",
              },
            });
          }
        }}
        onInputChange={(event, newInputValue) => {
          setSearchInput(newInputValue);
        }}
        isOptionEqualToValue={(option, value) => option.warehouseId === value?.warehouseId}
        renderInput={(params) => (
          <TextField
            {...params}
            className="mui-text-field"
            label="Select Warehouse"
            placeholder="Search by name or ID"
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {props.formDataFranchisee?.warehouseId && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          props.handleChangeFranchisee({
                            target: {
                              name: "warehouseId",
                              value: "",
                            },
                          });
                          setSearchInput("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton size="small">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <div style={{ fontWeight: 600 }}>{option.warehouseName}</div>
          </li>
        )}
        noOptionsText="No warehouses found"
        clearOnBlur={false}
      />

      {/* Cohort ID */}
      <TextField
        className="mui-text-field"
        label="Cohort ID"
        name="cohortId"
        value={props.cohortId || ""}
        InputProps={{
          readOnly: true,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled
        fullWidth
      />

      {/* Owner ID */}
      <TextField
        className="mui-text-field"
        label="Owner ID"
        name="ownerId"
        value={props.formDataFranchisee?.ownerId}
        onChange={props.handleChangeFranchisee}
        fullWidth
      />
    </div>
  );
};

export default CreateFranchiesComponent;

// import React, { useState } from "react";
// import "../ConfigurePayout.css";
// import {
//   Autocomplete,
//   TextField,
//   InputAdornment,
//   IconButton
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import ClearIcon from "@mui/icons-material/Clear";

// const CreateFranchiesComponent = (props) => {
//   const [searchInput, setSearchInput] = useState("");

//   // Filter warehouse list based on search input
//   const filteredWarehouses = props.warehouseList
//     ? props.warehouseList.filter((warehouse) =>
//         warehouse.warehouseName
//           ?.toLowerCase()
//           .includes(searchInput.toLowerCase()) ||
//         warehouse.warehouseId?.toString().includes(searchInput)
//       )
//     : [];

//   return (
//     <div className="fs-form-column" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
//       {/* Name */}
//       <TextField
//         className="mui-text-field"
//         label="Name"
//         name="name"
//         value={props.formDataFranchisee?.name}
//         onChange={props.handleChangeFranchisee}
//         fullWidth
//       />

//       {/* Description */}
//       <TextField
//         className="mui-text-field"
//         label="Description"
//         name="description"
//         value={props.formDataFranchisee?.description}
//         onChange={props.handleChangeFranchisee}
//         fullWidth
//       />

//       {/* Type */}
//       <TextField
//         className="mui-text-field"
//         label="Type"
//         name="type"
//         value={props.formDataFranchisee?.type}
//         onChange={props.handleChangeFranchisee}
//         fullWidth
//       />

//       {/* Warehouse Dropdown with Custom Search */}
//       <Autocomplete
//         options={filteredWarehouses}
//         getOptionLabel={(option) =>
//           `${option.warehouseName} (ID: ${option.warehouseId})`
//         }
//         value={
//           props.warehouseList?.find(
//             (wh) => wh.warehouseId === props.formDataFranchisee?.warehouseId
//           ) || null
//         }
//         onChange={(event, newValue) => {
//           if (newValue) {
//             props.handleChangeFranchisee({
//               target: {
//                 name: "warehouseId",
//                 value: newValue.warehouseId,
//               },
//             });
//           } else {
//             props.handleChangeFranchisee({
//               target: {
//                 name: "warehouseId",
//                 value: "",
//               },
//             });
//           }
//         }}
//         onInputChange={(event, newInputValue) => {
//           setSearchInput(newInputValue);
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             className="mui-text-field"
//             label="Select Warehouse"
//             placeholder="Search by name or ID"
//             fullWidth
//             InputProps={{
//               ...params.InputProps,
//               endAdornment: (
//                 <>
//                   {props.formDataFranchisee?.warehouseId && (
//                     <InputAdornment position="end">
//                       <IconButton
//                         size="small"
//                         onClick={() => {
//                           props.handleChangeFranchisee({
//                             target: {
//                               name: "warehouseId",
//                               value: "",
//                             },
//                           });
//                           setSearchInput("");
//                         }}
//                       >
//                         <ClearIcon />
//                       </IconButton>
//                     </InputAdornment>
//                   )}
//                   <InputAdornment position="end">
//                     <IconButton size="small">
//                       <SearchIcon />
//                     </IconButton>
//                   </InputAdornment>
//                   {params.InputProps.endAdornment}
//                 </>
//               ),
//             }}
//           />
//         )}
//         renderOption={(props, option) => (
//           <li {...props}>
//             <div style={{ fontWeight: 600 }}>{option.warehouseName}</div>
//           </li>
//         )}
//         noOptionsText="No warehouses found"
//         clearOnBlur={false}
//       />

//       {/* Cohort ID */}
//       <TextField
//         className="mui-text-field"
//         label="Cohort ID"
//         name="cohortId"
//         value={props.cohortId || ""}
//         InputProps={{
//           readOnly: true,
//         }}
//         InputLabelProps={{
//           shrink: true,
//         }}
//         disabled
//         fullWidth
//       />

//       {/* Owner ID */}
//       <TextField
//         className="mui-text-field"
//         label="Owner ID"
//         name="ownerId"
//         value={props.formDataFranchisee?.ownerId}
//         onChange={props.handleChangeFranchisee}
//         fullWidth
//       />
//     </div>
//   );
// };

// export default CreateFranchiesComponent;